import { useLayoutEffect, useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import useGetSalonById from 'sdk/hooks/salon/useGetSalonById';
import Page from 'modules/app/components/Page';
import s from './SalonProfile.module.scss';
import SalonProfileTop from './SalonProfileTop/SalonProfileTop';
import About from './About/About';
import { useActions } from 'store/useActions';
import Services from './Services/Services';
import TopMenuWithShare from 'modules/feed/components/Feed/TopMenuWithShare';
import { AppointmentBookingSteps } from 'modules/feed/components/Feed/Post/AppointmentBooking/AppointmentBooking';
import supabase from 'sdk/api';
import Vouchers from './Services/Vouchers/Vouchers';
import clsx from 'clsx';
import TimeStep from './Services/Vouchers/steps/TimeStep';
import ResultStep from './Services/Vouchers/steps/ResultStep';
import EmailStep from './Services/Vouchers/steps/EmailStep';
import Bundles from './Services/Vouchers/Bundles/Bundles';
import Steps from 'modules/feed/components/Feed/Post/AppointmentBooking/Steps';
import Products from './Services/Products/Products';
import { ReactComponent as ArrowRight } from 'images/new-icons/arrow-right.svg';
 
import { useTranslation } from 'react-i18next'; 

const SalonProfile = () => {
  const { id } = useParams();
  const location = useLocation();
  const { data, refetch } = useGetSalonById(id);
  const { setIsSlideChange } = useActions();
  const navigate = useNavigate();
  const {t} = useTranslation() as any
  const [step, setStep] = useState(AppointmentBookingSteps.CHOOSE_SERVICES);

  const [email, setEmail] = useState('');
  const [messageVaucher, setMessageVaucher] = useState('');
  const [deliveryDate, setDeliveryDate] = useState(null);
  const [selectedVoucher, setSelectedVoucher] = useState(null);

  const [activeTime, setActiveTime] = useState('now');
  const [error, setError] = useState(false);

  const tabs = [
    { id: 2, title: 'About' },
    { id: 3, title: 'Services' },
    { id: 4, title: 'Gift cards' },
    { id: 5, title: 'Bundles' },
    { id: 6, title: 'Products' },
  ];
  const [tab, setTab] = useState(location.state?.tab || tabs[0].id);

  const isChooseServices = AppointmentBookingSteps.CHOOSE_SERVICES;
  const isVoucherEmail = AppointmentBookingSteps.VOUCHER_EMAIL;
  const isVoucherTime = AppointmentBookingSteps.VOUCHER_TIME;
  const isVoucherResult = AppointmentBookingSteps.VOUCHER_RESULT;

  useLayoutEffect(() => {
    setIsSlideChange(false);
    if (location.state?.restoreScroll && location.state?.scrollPosition) {
      window.scrollTo(0, location.state.scrollPosition);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.state]);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (location.state?.restoreScroll && typeof location.state?.scrollPosition === 'number') {
      timeoutId = setTimeout(() => {
        window.scrollTo({
          top: location.state.scrollPosition,
          behavior: 'auto',
        });
      }, 0);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [location.state, tab]);

  const handleCloseMenu = () => {
    if (step === isChooseServices) {
      navigate(-1);
      return;
    }
    if (step === isVoucherEmail) {
      setStep(isChooseServices);
      return;
    }
    if (step === isVoucherTime) {
      setStep(isChooseServices);
      return;
    }
    if (step === isVoucherResult) {
      setStep(isChooseServices);
      return;
    }
  };

  const handleVoucherEmailStep = async () => {



    const { data: userByEmail, error: errorUserByEmail } = await supabase
      .from('user_profiles')
      .select('id')
      .eq('email', email)
      .limit(1);

    if (errorUserByEmail) {
      console.error(`Error fetching user by email: ${errorUserByEmail.message}`);
    }

  
    if (userByEmail?.length) {
      setStep(isVoucherTime);
    } else {
      setError(true);
    }
  };

  const handleTopBookClick = () => {
    navigate(`/appointment-booking/${id}`);
  }; 

  return (
    <div>
      <Page marginBottomNone activeLink="/venues">
        {step !== isVoucherEmail && step !== isVoucherTime && step !== isVoucherResult && (
          <TopMenuWithShare
            dark
            handleBack={handleCloseMenu}
            share={() => {
              navigator.share({
                title: t('Share'),
                text: t('Share'),
                url: window.location.href,
              });
            }}
          />
        )}

        <div className={clsx(s.container)}>
          <div className={s.containerInner}>
            {step !== isChooseServices &&
              step !== isVoucherEmail &&
              step !== isVoucherTime &&
              step !== isVoucherResult && <Steps step={step} />}
            {step === isChooseServices && (
              <>
                <SalonProfileTop
                  data={data}
                  refetch={refetch}
                  tab={tab}
                  setTab={setTab}
                  tabs={tabs}
                  onBookClick={handleTopBookClick}
                />
                {tab === 2 && data?.id && <About data={data} />}
                {tab === 3 && <Services data={data} setStep={setStep} />}
                {tab === 4 && (
                  <Vouchers
                    onBuy={voucher => {
                      setSelectedVoucher(voucher);
                      setStep(isVoucherEmail);
                    }}
                  />
                )}
                {tab === 5 && <Bundles salonId={data?.id} />}
                {tab === 6 && (
                  <div className={s.productsTabContent}>
                    <div className={s.services_title}>
                      <div className={s.services_title_title}>{t('Products')}</div>
                      <div
                        className={s.services_title_see}
                        onClick={() => {
                          const scrollPosition = Math.floor(window.scrollY);
                          navigate(`/salon/${data?.id}/products`, {
                            state: {
                              scrollPosition: scrollPosition,
                            },
                          });
                        }}
                      >
                        <div>{t('See All')}</div>
                        <ArrowRight />
                      </div>
                    </div>
                    <Products />
                  </div>
                )}
              </>
            )}

            {step === isVoucherEmail && (
              <EmailStep
                email={email}
                setEmail={setEmail}
                message={messageVaucher}
                setMessage={setMessageVaucher}
                onNext={handleVoucherEmailStep}
                onBack={handleCloseMenu}
                voucherData={selectedVoucher}
                error={error}
              />
            )}

            {step === isVoucherTime && (
              <TimeStep
                email={email}
                deliveryDate={deliveryDate}
                setDeliveryDate={setDeliveryDate}
                onNext={() => setStep(isVoucherResult)}
                onBack={handleCloseMenu}
                voucherData={selectedVoucher}
                activeTime={activeTime}
                setActiveTime={setActiveTime}
              />
            )}

            {step === isVoucherResult && (
              <ResultStep
                email={email}
                messageVaucher={messageVaucher}
                deliveryDate={deliveryDate}
                voucherData={selectedVoucher}
                onBack={handleCloseMenu}
                activeTime={activeTime}
                setActiveTime={setActiveTime}
              />
            )}
          </div>
        </div>
      </Page>
    </div>
  );
};

export default SalonProfile;
